import { Flag } from "@types"
import customFetch from "./helper"

/**
 * Get a flag by name
 */
export async function getFlag(flagName: string): Promise<Flag | null> {
  try {
    return await customFetch<Flag>(`/flags/${flagName}`)
  } catch (error: any) {
    if (error.status === 404) {
      return null
    }
    throw error
  }
}

/**
 * Set a flag by name
 */
export async function setFlag(flagName: string, value: boolean): Promise<Flag> {
  return await customFetch<Flag>(`/flags/${flagName}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ value }),
  })
}
